export enum ProgressPanelStatus {
	Draft = 'Draft',
	Scheduled = 'Scheduled',
	InProgress = 'In Progress',
	Closed = 'Closed',
	Cancelled = 'Cancelled',
}
